import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import {
  ref as databaseRef,
  onValue,
  push,
  remove,
  set,
  ref,
} from "firebase/database";
import "../styles/Config.css";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { FaTrash } from "react-icons/fa";

const Config = () => {
  const [cidades, setCidades] = useState({});
  const [novaCidade, setNovaCidade] = useState("");
  const [novoBairro, setNovoBairro] = useState({});

  const [atributos, setAtributos] = useState({});
  const [novoAtributo, setNovoAtributo] = useState("");

  const formatarTexto = (texto) => {
    return texto
      .toLowerCase()
      .replace(/(^|\s)([\p{L}\p{M}])/gu, (match) => match.toUpperCase());
  };

  useEffect(() => {
    const cidadesRef = ref(db, "loc/cidades");
    onValue(cidadesRef, (snapshot) => {
      const data = snapshot.val();
      setCidades(data || {});
    });
  }, []);

  useEffect(() => {
    const atributosRef = ref(db, "atributos");
    onValue(atributosRef, (snapshot) => {
      const data = snapshot.val();
      setAtributos(data || {});
    });
  }, []);

  const adicionarAtributo = () => {
    if (novoAtributo.trim() === "") return;
    const atributosRef = ref(db, "atributos");
    push(atributosRef, novoAtributo.trim()).then(() => setNovoAtributo(""));
  };

  const removerAtributo = (atributoKey) => {
    if (window.confirm("Tem certeza que deseja remover este atributo?")) {
      const atributoRef = ref(db, `atributos/${atributoKey}`);
      remove(atributoRef);
    }
  };

  const adicionarCidade = () => {
    if (novaCidade.trim() === "") return;
    const cidadeRef = ref(db, "loc/cidades");
    push(cidadeRef, { nome: formatarTexto(novaCidade), bairros: [] }).then(() =>
      setNovaCidade("")
    );
  };

  const adicionarBairro = (cidadeKey) => {
    if (!novoBairro[cidadeKey] || novoBairro[cidadeKey].trim() === "") return;
    const bairrosRef = ref(db, `loc/cidades/${cidadeKey}/bairros`);
    push(bairrosRef, formatarTexto(novoBairro[cidadeKey])).then(() => {
      setNovoBairro((prev) => ({ ...prev, [cidadeKey]: "" }));
    });
  };

  const removerCidade = (cidadeKey) => {
    if (window.confirm("Tem certeza que deseja remover esta cidade?")) {
      const cidadeRef = ref(db, `loc/cidades/${cidadeKey}`);
      remove(cidadeRef);
    }
  };

  const removerBairro = (cidadeKey, bairroKey) => {
    if (window.confirm("Tem certeza que deseja remover este bairro?")) {
      const bairroRef = ref(
        db,
        `loc/cidades/${cidadeKey}/bairros/${bairroKey}`
      );
      remove(bairroRef);
    }
  };

  return (
    <div className="containerConfig">
      <h1>Configurações</h1>

      <div style={{ marginLeft: "1%" }}>
        <Accordion sx={{ width: "70%", boxShadow: "none" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              border: "2px solid #ccc",
              borderRadius: "8px",
              mb: 2,
              bgcolor: "var(--cinzaClaro)",
            }}
          >
            <Typography>Configurações de Cidades e Bairros</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="addCidade">
              <input
                type="text"
                placeholder="Digite a cidade"
                value={novaCidade}
                onChange={(e) => setNovaCidade(formatarTexto(e.target.value))}
              />
              <button onClick={adicionarCidade}>Adicionar Cidade</button>
            </div>

            <div className="containerCidades">
              {Object.entries(cidades).map(([cidadeKey, cidade]) => (
                <div key={cidadeKey} className="cidadeBox">
                  <div className="cidadeHeader">
                    <span>{cidade.nome}</span>
                    <button onClick={() => removerCidade(cidadeKey)}>
                      REMOVER CIDADE
                    </button>
                  </div>
                  <div className="addBairro">
                    <input
                      type="text"
                      placeholder="Adicionar Bairro"
                      value={novoBairro[cidadeKey] || ""}
                      onChange={(e) =>
                        setNovoBairro((prev) => ({
                          ...prev,
                          [cidadeKey]: formatarTexto(e.target.value),
                        }))
                      }
                    />
                    <button onClick={() => adicionarBairro(cidadeKey)}>
                      +
                    </button>
                  </div>
                  <ul>
                    {cidade.bairros &&
                      Object.entries(cidade.bairros).map(
                        ([bairroKey, bairro]) => (
                          <li key={bairroKey}>
                            {bairro}{" "}
                            <button
                              onClick={() =>
                                removerBairro(cidadeKey, bairroKey)
                              }
                            >
                              <FaTrash />
                            </button>
                          </li>
                        )
                      )}
                  </ul>
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion sx={{ width: "70%", boxShadow: "none" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              border: "2px solid #ccc",
              borderRadius: "8px",
              mb: 2,
              bgcolor: "var(--cinzaClaro)",
            }}
          >
            <Typography>Atributos dos Imóveis</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="atributosConfig">
              <input
                type="text"
                placeholder="Novo atributo"
                value={novoAtributo}
                onChange={(e) => setNovoAtributo(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Evita submit de formulário ou reload
                    adicionarAtributo();
                  }
                }}
              />
              <button onClick={adicionarAtributo}>Adicionar Atributo</button>

              <ul>
                {Object.entries(atributos)
                  .sort((a, b) => a[1].localeCompare(b[1]))
                  .map(([atributoKey, atributo]) => (
                    <li key={atributoKey}>
                      {atributo}
                      <button
                        className="buttonAtributoDelete"
                        onClick={() => removerAtributo(atributoKey)}
                        style={{ marginLeft: "10px" }}
                      >
                        <FaTrash />
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>

      {/* <Accordion sx={{ width: "70%", boxShadow: "none" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            border: "2px solid #ccc",
            borderRadius: "8px",
            mb: 2,
            bgcolor: "var(--cinzaClaro)",
          }}
        >
          <Typography>Teste</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>proximas</Typography>
        </AccordionDetails>
      </Accordion> */}
    </div>
  );
};

export default Config;
